export const categories = [
  { id: "breakfast", label: "Breakfast" },
  { id: "lunch", label: "Lunch" },
  { id: "dinner", label: "Dinner" },
];

export const products = {
  breakfast: [
    {
      id: "continental-breakfast",
      name: "Continental Breakfast",
      image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg",
      rent: false,        // ordinary product
      appointment: false, // not an appointment
      withoutViewCompany:true
    },
    {
      id: "breakfast-delivery",
      name: "Breakfast Delivery",
      image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg",
      rent: false,
      appointment: true,  // requires appointment
      withoutViewCompany:true
    },
  ],
  lunch: [
    { id: "lunch-special", name: "Lunch Special", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
  ],
  dinner: [
    { id: "dinner-menu", name: "Dinner Menu", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false ,withoutViewCompany:true},
  ],
};